module.exports = __webpack_public_path__ + "img/PL00106.a1f4a87f.png";